<template>
    <modal
        name="reset-password"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        :classes="['v--modal', 'reset-password']"
        :width="730"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">
            {{ $t("restoringAccess.restoringAccess") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="modal-subtitle">
                {{ $t("newPassword.enterPhoneNumber") }}
            </div>
            <div class="reset-form-group">
                <input
                    v-model="username"
                    v-validate.persist="{
                        required: true,
                    }"
                    name="username"
                    type="text"
                    class="input"
                    :class="{ 'field-error': errors.has('username') }"
                />
                <!-- <label class="v-error">{{ errors.first('username') }}</label> -->
                <!-- <label class="v-error">
                    {{ errors.has('username') ?
                        ($t("newPassword.required") + (errors.first('username') === 'Пользователь не существует' ?
                            $t("newPassword.userDoesExist") : ''))
                        : '' }}
                </label> -->
                <label class="v-error">{{ errorMessage }}</label>
            </div>
            <div class="form-bottom buttons-center">
                <button @click="close" class="button-secondary">
                    {{ $t("stories.cancel") }}
                </button>
                <button
                    @click="resetPassword"
                    class="button"
                    :class="{ 'button-loader': loader }"
                >
                    {{ $t("newPassword.restore") }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "ResetPassword",
    props: {
        i18n: Object,
    },
    mixins: [localizeValidation, checkScroll],
    data() {
        return {
            loader: false,
            username: "",
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userErrors: "user/fetchUserErrors",
            resetType: "user/fetchResetType",
        }),
        errorMessage() {
            if (this.errors.has("username")) {
                if (
                    this.errors.first("username") ===
                    "Пользователь не существует"
                ) {
                    return this.$t("newPassword.userDoesExist");
                } else {
                    return this.$t("newPassword.required");
                }
            } else {
                return "";
            }
        },
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.close();
            }
        },
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
            this.localizeValidation();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        isNumeric(value) {
            return /^\d+$/.test(value);
        },
        formatPhoneNumber(phoneNumber) {
            // Удаляем все нецифровые символы из номера телефона и обрезаем до 11 символов
            let cleaned = ("" + phoneNumber)
                .replace(/\D/g, "")
                .substring(0, 11);
            // Если номер телефона начинается с "8", заменяем на "+7"
            if (cleaned.startsWith("8")) {
                cleaned = "7" + cleaned.slice(1);
            }
            // Добавляем формат
            let formatted = cleaned.replace(
                /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
                "+$1$2$3$4$5"
            );
            return formatted;
        },
        resetPassword() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    // Удаляем пробелы в конце строки перед форматированием номера телефона
                    let trimmedUsername = this.username.trim();
                    // Проверяем, если строка содержит ".ru" или ".com", то она скорее всего почта, а не номер телефона
                    let isEmail =
                        trimmedUsername.includes(".ru") ||
                        trimmedUsername.includes(".com");
                    // Форматируем номер телефона только если введены цифры и это не почта
                    let formattedUsername =
                        !isEmail && this.isNumeric(trimmedUsername)
                            ? this.formatPhoneNumber(trimmedUsername)
                            : trimmedUsername;

                    this.loader = true;
                    this.$store
                        .dispatch("user/resetPassword", {
                            username: formattedUsername,
                        })
                        .then(() => {
                            this.loader = false;
                            if (this.resetType == 1) {
                                this.$modal.show("dialog", {
                                    title: this.$t(
                                        "restoringAccess.restoringAccess"
                                    ),
                                    text: this.$t(
                                        "newPassword.passwordInstructionsEmail"
                                    ),
                                    buttons: [
                                        {
                                            title: this.$t("albumEdit.ok"),
                                        },
                                    ],
                                });
                            } else {
                                this.$store.dispatch(
                                    "user/setResetPhone",
                                    formattedUsername
                                );
                                this.$modal.show("reset-password-phone");
                            }
                            this.username = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.close();
                        })
                        .catch(() => {
                            this.loader = false;
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0],
                                });
                            }
                        });
                }
            });
        },
        // resetPassword() {
        //     this.$validator.validateAll()
        //         .then((valid) => {
        //             if (valid) {
        //                 this.loader = true;
        //                 this.$store.dispatch(
        //                     'user/resetPassword',
        //                     { username: this.username }
        //                 )
        //                     .then(() => {
        //                         this.loader = false;
        //                         if (this.resetType == 1) {
        //                             this.$modal.show('dialog', {
        //                                 title: this.$t("restoringAccess.restoringAccess"),
        //                                 text: this.$t("newPassword.passwordInstructionsEmail"),
        //                                 buttons: [
        //                                     {
        //                                         title: this.$t("albumEdit.ok")
        //                                     }
        //                                 ]
        //                             });
        //                         } else {
        //                             this.$store.dispatch('user/setResetPhone', this.username);
        //                             this.$modal.show('reset-password-phone');
        //                         }
        //                         this.username = '';
        //                         this.errors.clear();
        //                         this.$validator.reset();
        //                         this.close();
        //                     })
        //                     .catch(() => {
        //                         this.loader = false;
        //                         for (let key in this.userErrors) {
        //                             this.errors.add({
        //                                 field: key,
        //                                 msg: this.userErrors[key][0]
        //                             });
        //                         }
        //                     });
        //             }
        //         });
        // },
        close() {
            this.$modal.hide("reset-password");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
</style>

<style lang="scss">
@import "~@/assets/styles/layout/_reset-password";
</style>
